import { createRouter, createWebHistory } from "vue-router";

import TicketsHome from "../Vistas/Tickets/Home.vue";
import TicketsOperador from "../Vistas/Tickets/Operador.vue";

import PerfilAdmin from "@/Vistas/Personal/PerfilAdmin.vue";
import PersonalEdicion from "../Vistas/Personal/Edicion.vue";
import PersonalListado from "../Vistas/Personal/Listado.vue";
import CalificacionesColaborador from "../Vistas/Personal/Componentes/CalificacionesColaborador.vue";
import TomaFoto from "@/Vistas/Personal/TomaFoto.vue";

import Dashboards from "../Vistas/Dashboards/Default.vue";
import DatosGafete from "../Vistas/Personal/Componentes/DatosGafete.vue";
import DepartamentosListado from "../Vistas/Departamentos/Listado.vue";

import Colaboradores from "../Vistas/Personal/Componentes/Colaboradores.vue";
import GafetesListado from "../Vistas/Gafetes/Listado.vue";
import ListadoEstado from "../Vistas/Gafetes/ListaEstado.vue";
import PuestosListado from "../Vistas/Puestos/Listado.vue";
import PuestosEdicion from "../Vistas/Puestos/Edicion.vue";
import DepartamentosEdicion from "../Vistas/Departamentos/Edicion.vue";
import EncuestasListado from "../Vistas/Encuestas/Listado.vue";
import EncuestasEdicion from "../Vistas/Encuestas/Edicion.vue";
import UbicacionesListado from "../Vistas/Ubicaciones/Listado.vue";
import UbicacionesEdicion from "../Vistas/Ubicaciones/Edicion.vue";
import FotoEdicion from "../Vistas/Personal/TomaFoto.vue";
import SolicitudGafete from "../Vistas/Gafetes/SolicitudGafete.vue";
import ConfiguraciónIdioma from "../Vistas/AdminIdioma/Listado.vue";

import Default from "../Vistas/Dashboards/Default.vue";
import Automotive from "../views/dashboards/Automotive.vue";
import SmartHome from "../views/dashboards/SmartHome.vue";
import VRDefault from "../views/dashboards/vr/VRDefault.vue";
import VRInfo from "../views/dashboards/vr/VRInfo.vue";
import CRM from "../views/dashboards/CRM.vue";
import Overview from "../views/pages/profile/Overview.vue";
import Teams from "../views/pages/profile/Teams.vue";
import Projects from "../views/pages/profile/Projects.vue";
import General from "../views/pages/projects/General.vue";
import Timeline from "../views/pages/projects/Timeline.vue";
import NewProject from "../views/pages/projects/NewProject.vue";
import Pricing from "../views/pages/Pricing.vue";
import RTL from "../views/pages/Rtl.vue";
import Charts from "../views/pages/Charts.vue";
import SweetAlerts from "../views/pages/SweetAlerts.vue";
import Notifications from "../views/pages/Notifications.vue";
import Kanban from "../views/applications/Kanban.vue";
import Wizard from "../views/applications/wizard/Wizard.vue";
import DataTables from "../views/applications/DataTables.vue";
import Calendar from "../views/applications/Calendar.vue";
import Analytics from "../views/applications/analytics/Analytics.vue";
import EcommerceOverview from "../views/ecommerce/overview/Overview.vue";
import NewProduct from "../views/ecommerce/products/NewProduct.vue";
import EditProduct from "../views/ecommerce/EditProduct.vue";
import ProductPage from "../views/ecommerce/ProductPage.vue";
import ProductsList from "../views/ecommerce/ProductsList.vue";
import OrderDetails from "../views/ecommerce/Orders/OrderDetails";
import OrderList from "../views/ecommerce/Orders/OrderList";
import Referral from "../views/ecommerce/Referral";
import Reports from "../views/pages/Users/Reports.vue";
import NewUser from "../views/pages/Users/NewUser.vue";
import Settings from "../views/pages/Account/Settings.vue";
import Billing from "../views/pages/Account/Billing.vue";
import Invoice from "../views/pages/Account/Invoice.vue";
import Security from "../views/pages/Account/Security.vue";
import Widgets from "../views/pages/Widgets.vue";
import Basic from "../views/auth/signin/Basic.vue";
import Cover from "../views/auth/signin/Cover.vue";
import Illustration from "../views/auth/signin/Illustration.vue";
import ResetBasic from "../views/auth/reset/Basic.vue";
import ResetCover from "../views/auth/reset/Cover.vue";
import ResetIllustration from "../views/auth/reset/Illustration.vue";
import VerificationBasic from "../views/auth/verification/Basic.vue";
import VerificationCover from "../views/auth/verification/Cover.vue";
import VerificationIllustration from "../views/auth/verification/Illustration.vue";
import SignupBasic from "../views/auth/signup/Basic.vue";
import SignupCover from "../views/auth/signup/Cover.vue";
import SignupIllustration from "../views/auth/signup/Illustration.vue";
import Error404 from "../views/auth/error/Error404.vue";
import Error500 from "../views/auth/error/Error500.vue";
import lockBasic from "../views/auth/lock/Basic.vue";
import lockCover from "../views/auth/lock/Cover.vue";
import lockIllustration from "../views/auth/lock/Illustration.vue";

const routes = [
  {
    path: "/",
    name: "/",
  },
  {
    path: "/login",
    name: "Inicio de sesión",
    component: () =>
      import(
        /* webpackChunkName: "usuarios" */ "@/Vistas/Usuarios/InicioSesion.vue"
      ),
  },
  {
    path: "/id_token*",
    name: "id_token",
    component: () =>
      import(
        /* webpackChunkName: "usuarios" */ "@/Vistas/Usuarios/State.vue"
      ),
  },
  {
    path: "/error*",
    name: "error",
    component: () =>
      import(
        /* webpackChunkName: "usuarios" */ "@/Vistas/Usuarios/Presenta.vue"
      ),
  },
  {
    path: "/state*",
    name: "state",
    component: () =>
      import(
        /* webpackChunkName: "usuarios" */ "@/Vistas/Usuarios/State.vue"
      ),
  },
  {
    path: "/dashboards/dashboard-default",
    name: "Default",
    component: Default,
  },
  {
    path: "/dashboards/landing",
    name: "Landing",
    component: Default,
  },
  {
    path: "/dashboards/automotive",
    name: "Automotive",
    component: Automotive,
  },
  {
    path: "/topicos",
    name: "Topicos",
    component: () =>
      import(
        /* webpackChunkName: "topicos" */ "@/Vistas/Topicos/Listado.vue"
      ),
    meta: { requiresAuth: true },
  },
  {
    path: "/topicos/:id",
    name: "Topico",
    component: () =>
      import(
        /* webpackChunkName: "topicos" */ "@/Vistas/Topicos/Edicion.vue"
      ),
    meta: { requiresAuth: true },
  },
  {
    path: "/tickets",
    name: "Tickets",
    component: () =>
      import(
        /* webpackChunkName: "tickets" */ "@/Vistas/Tickets/Home.vue"
      ),
    meta: { requiresAuth: true },
  },
  {
    path: "/tickets/operador",
    name: "Operador",
    component: () =>
      import(
        /* webpackChunkName: "tickets" */ "@/Vistas/Tickets/Operador.vue"
      ),
    meta: { requiresAuth: true },
  },
  {
    path: "/tickets/:id",
    name: "Edicion de ticket",
    component: () =>
      import(
        /* webpackChunkName: "tickets" */ "@/Vistas/Tickets/Edicion.vue"
      ),
      meta: { requiresAuth: true },
  },
  {
    path: "/tickets/operador/:id",
    name: "Edicion de ticket o",
    component: () =>
      import(
        /* webpackChunkName: "tickets" */ "@/Vistas/Tickets/Edicion.vue"
      ),
      meta: { requiresAuth: true },
  },
  {
    path: "/personal",
    name: "Colaboradores",
    component: PersonalListado,
    meta: { requiresAuth: true },
  },
  {
    path: "/personal/:id/tomafoto",
    name: "TomaFoto",
    component: TomaFoto,
  },

  {
    path: "/departamentos",
    name: "Departamentos",
    component: DepartamentosListado,
    meta: { requiresAuth: true },
  },
  {
    path: "/departamentos/:id",
    name: "Departamento",
    component: DepartamentosEdicion,
    meta: { requiresAuth: true },
  },
  {
    path: "/personal/edicion/:id",
    name: "PersonalEdicion",
    component: PersonalEdicion,
    meta: { requiresAuth: true },
  },
  {
    path: "/personal/:id",
    name: "Colaborador",
    component: PersonalEdicion,
    meta: { requiresAuth: true },
  },
  {
    path: "/personal/edicion/identificacion",
    name: "Identificacion",
    component: DatosGafete,
  },

  {
    path: "/editafoto",
    name: "Fotografia del colaborador",
    component: FotoEdicion,
  },
  {
    path: "/puestos",
    name: "Puestos",
    component: PuestosListado,
  },
  {
    path: "/puestos/:id",
    name: "Puesto",
    component: PuestosEdicion,
    meta: { requiresAuth: true },
  },
  {
    path: "/gafetes",
    name: "Gafetes",
    component: GafetesListado,
  },

  {
    path: "/gafeteslista",
    name: "GafetesLista",
    component: ListadoEstado,
  },


  {
    path: "/personal/calificaciones",
    name: "CalificacionesColaborador",
    component: CalificacionesColaborador,
  },
  {
    path: "/admin",
    name: "PerfilAdmin",
    component: PerfilAdmin,
  },
  /* {
    path: "/admin/:id",
    name: "PerfilAdmin",
    component: PerfilAdmin,
    meta: { requiresAuth: true },

  }, */
  {
    path: "/Ubicaciones",
    name: "Sucursales",
    component: UbicacionesListado,
  },
  {
    path: "/Ubicaciones/:id",
    name: "Sucursal",
    component: UbicacionesEdicion,
    meta: { requiresAuth: true },
  },
  {
    path: "/encuestas",
    name: "Encuestas",
    component: EncuestasListado,
  },
  {
    path: "/solicitud/:id",
    name: "Gafete del colaborador",
    component: SolicitudGafete,
    meta: { requiresAuth: true },
  },
  {
    path: "/encuestas/:id",
    name: "Encuesta",
    component: EncuestasEdicion,
    meta: { requiresAuth: true },
  },
  {
    path: "/dashboards",
    name: "Dashboards",
    component: Dashboards,
  },
  {
    path: "/configidioma",
    name: "ConfiguraciónIdioma",
    component: ConfiguraciónIdioma,
  },
  
  {
    path: "/dashboards/smart-home",
    name: "Smart Home",
    component: SmartHome,
  },
  {
    path: "/dashboards/vr/vr-default",
    name: "VR Default",
    component: VRDefault,
  },
  {
    path: "/dashboards/vr/vr-info",
    name: "VR Info",
    component: VRInfo,
  },
  {
    path: "/dashboards/crm",
    name: "CRM",
    component: CRM,
  },
  {
    path: "/pages/profile/overview",
    name: "Profile Overview",
    component: Overview,
  },
  {
    path: "/pages/profile/teams",
    name: "Teams",
    component: Teams,
  },
  {
    path: "/pages/profile/projects",
    name: "All Projects",
    component: Projects,
  },
  {
    path: "/pages/projects/general",
    name: "General",
    component: General,
  },
  {
    path: "/pages/projects/timeline",
    name: "Timeline",
    component: Timeline,
  },
  {
    path: "/pages/projects/new-project",
    name: "New Project",
    component: NewProject,
  },
  {
    path: "/pages/pricing-page",
    name: "Pricing Page",
    component: Pricing,
  },
  {
    path: "/pages/rtl-page",
    name: "RTL",
    component: RTL,
  },
  {
    path: "/pages/charts",
    name: "Charts",
    component: Charts,
  },
  {
    path: "/pages/widgets",
    name: "Widgets",
    component: Widgets,
  },
  {
    path: "/pages/sweet-alerts",
    name: "Sweet Alerts",
    component: SweetAlerts,
  },
  {
    path: "/pages/notifications",
    name: "Notifications",
    component: Notifications,
  },
  {
    path: "/applications/kanban",
    name: "Kanban",
    component: Kanban,
  },
  {
    path: "/applications/wizard",
    name: "Wizard",
    component: Wizard,
  },
  {
    path: "/applications/data-tables",
    name: "Data Tables",
    component: DataTables,
  },
  {
    path: "/applications/calendar",
    name: "Calendar",
    component: Calendar,
  },
  {
    path: "/applications/analytics",
    name: "Analytics",
    component: Analytics,
  },
  {
    path: "/ecommerce/overview",
    name: "Overview",
    component: EcommerceOverview,
  },
  {
    path: "/ecommerce/products/new-product",
    name: "New Product",
    component: NewProduct,
  },
  {
    path: "/ecommerce/products/edit-product",
    name: "Edit Product",
    component: EditProduct,
  },
  {
    path: "/ecommerce/products/product-page",
    name: "Product Page",
    component: ProductPage,
  },
  {
    path: "/ecommerce/products/products-list",
    name: "Products List",
    component: ProductsList,
  },
  {
    path: "/ecommerce/Orders/order-details",
    name: "Order Details",
    component: OrderDetails,
  },
  {
    path: "/ecommerce/Orders/order-list",
    name: "Order List",
    component: OrderList,
  },
  {
    path: "/ecommerce/referral",
    name: "Referral",
    component: Referral,
  },
  {
    path: "/pages/users/reports",
    name: "Reports",
    component: Reports,
  },
  {
    path: "/pages/users/new-user",
    name: "New User",
    component: NewUser,
  },
  {
    path: "/pages/account/settings",
    name: "Settings",
    component: Settings,
  },
  {
    path: "/pages/account/billing",
    name: "Billing",
    component: Billing,
  },
  {
    path: "/pages/account/invoice",
    name: "Invoice",
    component: Invoice,
  },
  {
    path: "/pages/account/Security",
    name: "Security",
    component: Security,
  },
  {
    path: "/authentication/signin/basic",
    name: "Signin Basic",
    component: Basic,
  },
  {
    path: "/authentication/signin/cover",
    name: "Signin Cover",
    component: Cover,
  },
  {
    path: "/authentication/signin/illustration",
    name: "Signin Illustration",
    component: Illustration,
  },
  {
    path: "/authentication/reset/basic",
    name: "Reset Basic",
    component: ResetBasic,
  },
  {
    path: "/authentication/reset/cover",
    name: "Reset Cover",
    component: ResetCover,
  },
  {
    path: "/authentication/reset/illustration",
    name: "Reset Illustration",
    component: ResetIllustration,
  },
  {
    path: "/authentication/lock/basic",
    name: "Lock Basic",
    component: lockBasic,
  },
  {
    path: "/authentication/lock/cover",
    name: "Lock Cover",
    component: lockCover,
  },
  {
    path: "/authentication/lock/illustration",
    name: "Lock Illustration",
    component: lockIllustration,
  },
  {
    path: "/authentication/verification/basic",
    name: "Verification Basic",
    component: VerificationBasic,
  },
  {
    path: "/authentication/verification/cover",
    name: "Verification Cover",
    component: VerificationCover,
  },
  {
    path: "/authentication/verification/illustration",
    name: "Verification Illustration",
    component: VerificationIllustration,
  },
  {
    path: "/authentication/signup/basic",
    name: "Signup Basic",
    component: SignupBasic,
  },
  {
    path: "/authentication/signup/cover",
    name: "Signup Cover",
    component: SignupCover,
  },
  {
    path: "/authentication/signup/illustration",
    name: "Signup Illustration",
    component: SignupIllustration,
  },
  {
    path: "/authentication/error/error404",
    name: "Error Error404",
    component: Error404,
  },
  {
    path: "/authentication/error/error500",
    name: "Error Error500",
    component: Error500,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: "active",
});

export default router;
